import { useQueryData } from "hooks";
import { GET_MISSION_ROLE_TEMPLATE } from "graphql/queries";

/**
 * useMissionRoleTemplate
 *
 * One blueprint with its vetting modules, read back after each module saves.
 *
 * @param {String}  id  The blueprint's uuid or slug
 */
export default function useMissionRoleTemplate({ id }) {
  const { data, loading, error, refetch } = useQueryData({
    queryName: GET_MISSION_ROLE_TEMPLATE,
    keyName: "missionRoleTemplate",
    variables: { id },
    skip: !id,
    disablePagination: true,
  });

  return { template: data?.missionRoleTemplate, loading, error, refetch };
}
